<div class="header">
    <div class="header-actions" *ngIf="!disabled">
        <h4>{{ 'brand.prepTime.prepPeriods' | translate }}</h4>
        <div class="actions-container">
            <txp-button data-qa-label="AddHoursButton"
                        [style]="buttonStyle.SECONDARY"
                        [size]="buttonSize.SMALL"
                        (click)="addListItem()">
                {{ 'brand.storeHours.addHours' | translate }}
            </txp-button>
        </div>
    </div>
</div>
<div class="form-content">
    <div class="prep-times-list" [formGroup]="form" formSubmittedSync>
        <div class="prep-times-list-item"
             formArrayName="items"
             *ngFor="let item of form.get('items')['controls']; let i = index;">
            <mat-form-field class="prep-times-days" [formGroupName]="i">
                <mat-label>{{ 'brand.storeHours.day' | translate }}</mat-label>
                <mat-select  #select multiple
                    formControlName="days"
                    data-qa-label="Days"
                    required
                    panelClass="store-hours-days-panel">
                <txp-select-check-all *ngIf="i === 0" [model]="item.get('days')"
                    [values]="daysOfWeek"
                    (allSelected)="allSelected=$event"
                    [text]="'calendar.selectAll' | translate">
                </txp-select-check-all>
                <ng-container *ngFor="let day of daysOfWeek">
                    <mat-option [value]="day">{{ 'calendar.days.' + day | translate }}</mat-option>
                </ng-container>
            </mat-select>
                <mat-error>
                    {{ 'form.error.required' | translate }}
                </mat-error>
            </mat-form-field>
            <mat-form-field class="prep-times-start-time" [formGroupName]="i">
                <mat-label>{{ 'brand.storeHours.startTime' | translate }}</mat-label>
                <input id="startTime"
                       data-qa-label="StartTime"
                       required
                       formControlName="startTime"
                       maxlength="5"
                       matInput/>
                <mat-hint>{{ 'form.hint.time24HrFormat' | translate }}</mat-hint>
                <mat-error *ngIf="item.get('startTime').errors?.required">
                    {{ 'form.error.required' | translate }}
                </mat-error>
                <mat-error *ngIf="item.get('startTime').errors?.pattern">
                    {{ 'form.error.invalidTimeFormat' | translate }}
                </mat-error>
                <mat-error *ngIf="item.get('startTime').errors?.beforeTime">
                    {{ 'form.error.startTimeAfterEndTime' | translate}}
                </mat-error>
            </mat-form-field>

            <mat-form-field class="prep-times-end-time" [formGroupName]="i">
                <mat-label>{{ 'brand.storeHours.endTime' | translate }}</mat-label>
                <input id="endTime"
                       data-qa-label="EndTime"
                       required
                       formControlName="endTime"
                       maxlength="5"
                       matInput/>
                <mat-hint>{{ 'form.hint.time24HrFormat' | translate }}</mat-hint>
                <mat-error *ngIf="item.get('endTime').errors?.required">
                    {{ 'form.error.required' | translate }}
                </mat-error>
                <mat-error *ngIf="item.get('endTime').errors?.pattern">
                    {{ 'form.error.invalidTimeFormat' | translate }}
                </mat-error>
                <mat-error *ngIf="item.get('endTime').errors?.afterTime">
                    {{ 'form.error.endTimeBeforeStartTime' | translate}}
                </mat-error>
            </mat-form-field>

            <mat-form-field class="prep-times-prep-time" [formGroupName]="i">
                <mat-label>{{ 'store.prepTimes.prepTime' | translate }}</mat-label>
                <input id="prepTime"
                       data-qa-label="PrepTime"
                       formControlName="prepTime"
                       required
                       maxlength="5"
                       txpIntegersOnly
                       matInput/>
                <mat-error *ngIf="item.get('prepTime').errors?.required">
                    {{ 'form.error.required' | translate }}
                </mat-error>
                <mat-error *ngIf="item.get('prepTime').errors?.pattern">
                    {{ 'form.error.invalidNumberFormat' | translate }}
                </mat-error>
            </mat-form-field>

            <button mat-button class="btn-remove"
                    type="button"
                    data-qa-label="RemoveButton"
                    *ngIf="!disabled && defaultRowNotRequired"
                    (click)="removeListItem(i)"><i class="tce-icon-trash"></i></button>
        </div>
    </div>
</div>
